export default "__VITE_ASSET__CInGJ8gd__"